/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  
    // For FAQ page, when tabbing on the sidebar header, the focus will go to the correct header section
  	  document.addEventListener('click', function (event) {
		    const link = event.target.closest('widget__link{% if first_element_flag %} is-selected{% endif %}');
		    if (!link) return;

		    const id = link.getAttribute('href').slice(1);
		    const target = document.getElementById(id);
		    if (!target) return;

		    target.setAttribute('tabindex', '-1');
		    target.focus();
		  });



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
